/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={'Toolber':{}};
if(!window.GS.Toolbar) GS.Toolbar={};
(function(){
    var _registerd = 0,
        f;
    
    f = new Class({
        Extends: GS.BaseClass,
        class_name:'GS.Toolbar.Tools',
        options:{
            'wrapper': null,
            'class':'submenu full',
            'lexico':{'x':'X','y':'Y','o':'O','b':'B'},
            'toolbar':null,
            'permission_property':null
        },
        controlled:null,
        initialize:function(conf){
           this.parent(conf);
           this.options.lexico.confirms=Locale.get('Toolbar.confirms');
           
        }
    });

    /**
     * 
     * @param {type} t
     * @returns {void}
     */
    f.prototype.attachToToolbar=function(t){
        var self=this,w=this.options.wrapper,type=self.options.type;
        this.toolbar=t;
        this.register('no:selection',function(o,permission){
           //console.debug('Attach to:',o);
           self.controlled=o;
           if(!o) return;
           self.updatePermissions(permission);
        });

        this.register('active:frame',function(o,permission){
           //console.debug('Attach to:',o); 
           self.controlled=o;
           if(!o) return;
           self.updatePermissions(permission);
        });

        this.register('toolbar:submenu',function(t) {
            if (w !== t) {
                w.removeClass('selected');
                if (this.sm) this.sm.setStyle('display', 'none');
            } else {
                if (this.sm) this.sm.fireEvent('show');
            }
        }.bind(this));

        this.register('toolbar:update:permissions', function (o) {
            self.updatePermissions(o ? o.getPermissions() : {});
        });

        t.addEvent('submenu:show',function(t){
            if(w!==t)  {
                w.removeClass('selected');
                if(this.sm) this.sm.setStyle('display','none');
            }else{

                //if(this.sm) this.sm.fireEvent('show');
                this.dispatch('toolbar:submenu', t);
            }
        }.bind(this));



       /* t.addEvent('linkedTo',function(o){
           self.controlled=o;
           if(!o) return;
           self.updatePermissions(o.getPermissions());
        });*/
        this.configureTools();
    };

    /**
     * 
     * @param {Object} permissions
     * @returns {void}
     */
    f.prototype.updatePermissions=function(permissions){
        var vis=false,
            self=this,
            use=this.options.permission_property;

        if(!use.pop) use=[use];
        Array.each(use,function(prop,i){
            if(typeof permissions[prop]==='object'){
                Object.each(permissions[prop],function(v,p){
                    if(v) vis=true;
                    self.fireEvent(p,v);
                });
            }else{
                if(permissions[prop]===true) vis=true;
                self.fireEvent(prop,permissions[prop]);
            }
        });
        //if(permissions.delete) vis = true;
        //console.info('Toolbar is visible: %s', vis, permissions, use);
        this.options.wrapper.setStyle('display',(vis) ? 'block' : 'none');
        if(vis) this.toolbar.fireEvent('show');
    };
    /**
     * Configure toolbar tools....
     **/
    f.prototype.configureTools=function(){

        var self=this;
        this.sm=new Element('ul',{'class':this.options['class']}).set('html',this.menuTMPL().substitute(this.options.lexico));
        var ctrl=this.sm.getElements('li'),
            w=this.options.wrapper;

        Array.each(ctrl,function(ctr,i){
            var type=ctr.getAttribute('data-type'),
                ui=ctr.getAttribute('data-uitype'),
                _nextSibling = ctr.nextElementSibling;
            
            
            if(!_nextSibling || _nextSibling.nodeName === '#text') {
                _nextSibling = null;
            }else{
                $(_nextSibling);
            }

            switch(type){
                case 'apply-border-onallframes-onpage':
                case 'apply-border-onpage':
                    var skipMasksAndFrames = type !== 'apply-border-onallframes-onpage';
                    ctr.addEventListener('click', function(e){
                        //console.warn('SEND TO THE SELECTED ELEMENT THE COMMAND/TASK “%s“', type);
                        if(self.controlled) {
                            window.requestAnimationFrame(function(){
                                self.controlled.fireEvent('border:get', function (border) {
                                    self.dispatch('apply-border-onpage', border, skipMasksAndFrames)
                                });
                            })
                        }
                    });
                    break;

                case 'apply-border-ondoc':
                case 'remove-border-onpage':
                    ctr.addEventListener('click', function(e){
                        //console.warn('SEND TO THE SELECTED ELEMENT THE COMMAND/TASK “%s“', type);
                        if(self.controlled) {
                            self.controlled.fireEvent('border:get', function (border) {
                                self.dispatch(type, border)
                            });
                        }
                    });
                    break;

                case 'remove-border':
                case 'remove-mask':
                case 'remove-frame':
                case 'remove-all-effects':
                case 'reset-colors-effects':
                    ctr.addEventListener('click', function(e){
                        //console.warn('SEND TO THE SELECTED ELEMENT THE COMMAND/TASK “%s“', type);
                        if(self.controlled) self.controlled.fireEvent(type);
                    })
                    break;
            }
            //console.warn('---->', ui);
            switch(ui){
                case 'slider_w_input':
                case 'slider':
                    var sl=new GS.Toolbar.Slider(ctr,{'debug':0,'property':type,'value':0});
                    sl.addEvent('change',function(v){
                        var val = (!isNaN(v) && (type === 'shadow-opacity' || type === 'inner-shadow-opacity' || type === 'alpha'|| type === 'zoom')) ? v/100 : v;
                        
                        //if(self.controlled &&  type === 'zoom') self.controlled.fireEvent(type+':start');
                        //console.warn(type, v);
                        if(typeof v !== 'undefined') self.controlled.fireEvent(type+':set', Number(val));
                        if(sl.inputField){
                            sl.inputField.setValue(Number(v));
                        }
                    });
                    sl.addEvent('start',function(){
                        if(self.controlled) self.controlled.fireEvent(type+':start');  
                    });
                    sl.addEvent('end',function(){
                        if(self.controlled) self.controlled.fireEvent(type+':end');  
                        self.dispatch('user:interaction',1);
                    });
                    if(ui == "slider_w_input"){
                        sl.inputField = new GS.Toolbar.Input(ctr,{'property':type});
                        sl.inputField.addEvent('input:change',function(v){
                            var val = (!isNaN(v) && (type === 'shadow-opacity' || type === 'inner-shadow-opacity' || type === 'alpha' || type === 'zoom')) ? v/100 : v;
                            sl.fireEvent('set',v, true);
                            if(self.controlled) {
                                self.controlled.fireEvent(type+':start');
                                self.controlled.fireEvent(type+':set',val);
                                self.controlled.fireEvent(type+':end');
                            }
                            self.dispatch('user:interaction',1);
                        });
                    }
                    switch(type){
                        case 'alpha':
                            var currentAlpha= 100;
                            sl.setMinMax(0,100, 0.1);
                            self.sm.addEvent('show',function(active){
                               // if(self.controlled.getAlpha) sl.fireEvent('set',self.controlled.getAlpha());
                                if(self.controlled) {
                                    self.controlled.fireEvent(type+':get',function(v){
                                        sl.fireEvent('set',v*100);
                                    });
                                }
                                
                            });
                            
                            self.addEvent('alpha',function(active){
                               //console.debug('GET ALPHA VALUE');
                               if(active) {
                                   currentAlpha=self.controlled.getAlpha();
                                   sl.fireEvent('disabled',false);
                                   ctr.setStyle('display','block');
                                   if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                               }else{
                                   sl.fireEvent('disabled',true);
                                   ctr.setStyle('display','none');
                                   
                                   if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                               }
                            });
                        break;
                        case 'zoom':
                            var currentZoom=0;
                            sl.setMinMax(0, 100, 0.1);
                            self.sm.addEvent('show',function(active){
                                if(self.controlled) {
                                    self.controlled.fireEvent(type+':get',function(v){
                                        sl.fireEvent('set',v*100);
                                        if(sl.inputField){
                                            sl.inputField.setValue(Number(v)*100);
                                        }
                                    });
                                }
                                //sl.fireEvent('set',self.controlled.getZoom());
                            });
                            self.addEvent('zoom',function(active){
                               if(active) {
                                   //currentZoom=self.controlled.getZoom();
                                   sl.fireEvent('disabled',false);
                                   ctr.setStyle('display','block');
                                   if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                               }else{
                                   sl.fireEvent('disabled',true);
                                   ctr.setStyle('display','none');
                                   if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                               }
                            });
                        break;
                        case 'border-opacity':
                        case 'border-size':
                             if(type==='border-size') sl.setMinMax(0,30,0.1);
                             if(type==='border-opacity') sl.setMinMax(0,1,0.1);
                             self.sm.addEvent('show',function(active){
                                if(self.controlled) {
                                    self.controlled.fireEvent(type+':get',function(v){
                                        sl.fireEvent('set',v);
                                    });
                                }
                                //sl.fireEvent('set',self.controlled.getZoom());
                            });
                            /* self.sm.addEvent('show',function(active){
                                var s=self.controlled.getBorder(type);
                                sl.fireEvent('set',s);
                            });*/

                            self.sm.addEvent('disabled',function(s){
                                sl.fireEvent('disabled',s);
                            });

                        break;
                        case 'shadow-x':
                        case 'shadow-y':
                        case 'shadow-opacity':
                        case 'shadow-blur':
                            //console.warn('Type: %s', type);
                            if(type==='shadow-opacity') sl.setMinMax(0, 100, 0.1);   
                            if(type==='shadow-x' || type==='shadow-y') sl.setMinMax(-25,25, 0.1);
                            if(type==='shadow-blur') sl.setMinMax(0,50, 0.1);

                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getShadow(type);
                                if(type==='shadow-opacity') s*=100;
                                sl.fireEvent('set',s);
                            });

                            self.sm.addEvent('disabled',function(s){
                                sl.fireEvent('disabled',s);
                            });

                            sl.fireEvent('disabled',true);

                        break;
                        case 'inner-shadow-x':
                        case 'inner-shadow-y':
                        case 'inner-shadow-opacity':
                        case 'inner-shadow-blur':
                            //console.warn('Type: %s', type);
                            if(type==='inner-shadow-opacity') sl.setMinMax(0, 100, 0.1);
                            if(type==='inner-shadow-x' || type==='inner-shadow-y') sl.setMinMax(-25,25, 0.1);
                            if(type==='inner-shadow-blur') sl.setMinMax(0,50, 0.1);

                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getInnerShadow(type);
                                if(type==='inner-shadow-opacity') s*=100;
                                sl.fireEvent('set',s);
                            });

                            self.sm.addEvent('disabled',function(s){
                                sl.fireEvent('disabled',s);
                            });

                            sl.fireEvent('disabled',true);

                            break;
                        case 'effect-hue':
                        case 'effect-lightness':
                        case 'effect-brightness':
                        case 'effect-saturation':
                        case 'effect-contrast':
                            sl.setMinMax(-100,100,1);  
                            if(type==='effect-brightness') sl.setMinMax(100,-100,0.1);
                            if(type==='effect-hue') sl.setMinMax(-180,180,0.1);
                            self.sm.addEvent('show',function(active){
                                
                                var s=self.controlled.getColors(type);
                                sl.fireEvent('set',s);
                            });
                            
                            self.addEvent('reset-colors-effects',function(e){
                                var s = 0;
                                sl.fireEvent('set',s);
                                self.controlled.fireEvent(type,s);
                                self.dispatch('user:interaction',1);
                             });
                        break;
                        case 'object-effect-hue':
                        case 'object-effect-saturation':
                        case 'object-effect-lightness':
                            sl.setMinMax(-100,100);  
                            if(type==='object-effect-lightness') sl.setMinMax(100,-100);
                            if(type==='object-effect-hue') sl.setMinMax(-180,180);
                            self.addEvent('reset-object-effects',function(e){
                                var s = 0;
                                sl.fireEvent('set',s);
                                self.controlled.fireEvent(type,s);
                                self.dispatch('user:interaction',1);
                             });
                            self.sm.addEvent('show',function(active){
                               var s=self.controlled.fireEvent(type+':get',function(val){
                                   sl.fireEvent('set',val);
                               });
                            });
                        break;
                    }
                break;   
                
                /** COLOR PICKERS **/   
                case 'colorpicker':
                    if(window.$j) {
                        var lEle = $j('#toolbar-shadow-color');
                        switch (type) {
                            case 'inner-shadow-color':
                                lEle = $j('#toolbar-inner-shadow-color');
                                break;
                            case 'background-color':
                                lEle = $j('#toolbar-background-color');
                                break;
                            case 'object-effect-color':
                                lEle = $j('#toolbar-objecteffect-color');
                                break;
                            case 'object-whithepoint-color':
                                lEle = $j('#toolbar-whitepoint-color');
                                break;
                            case 'object-blackpoint-color':
                                lEle = $j('#toolbar-black-color');
                                break;

                        }
                        var cPreview = ctr.getElement('.color-placeholder');
                        var currentColor = null,
                            changed = 0,
                            transparent = 0,
                            cp = $j(ctr).ColorPicker({
                                color: '#000000',
                                flat: false,
                                onShow: function (colpkr) {
                                    $j(colpkr).fadeIn(500);
                                    return false;
                                },
                                onHide: function (hsb, hex, rgb, el) {
                                    $j(el).fadeOut(500);
                                    currentColor = null;

                                    if (changed && self.controlled) self.controlled.fireEvent(type + ':end', rgb);
                                    changed = 0;
                                    self.dispatch('user:interaction', 1);
                                    return false;
                                },
                                onSubmit: function (hsb, hex, rgb, el) {
                                    //console.info('asioidsaoidsa');
                                },
                                onChange: function (hsb, hex, rgb) {
                                    cPreview.setStyle('background-color', 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')');
                                    transparent = (rgb.r + rgb.g + rgb.b === 765);
                                    changed = 1;
                                    console.warn('EVENT TYPE: %s:set', type);
                                    cPreview.classList[(transparent) ? 'add' : 'remove']('transparent');
                                    if (self.controlled) self.controlled.fireEvent(type + ':set', rgb);
                                    return false;
                                },
                                onBeforeShow: function () {
                                    changed = 0;
                                    transparent = 0;
                                    if (currentColor) $j(this).ColorPickerSetColor(currentColor);
                                }
                            });

                        //console.warn(ctr);
                        switch (type) {
                            case 'background-color':
                                self.addEvent('background-color', function (active) {
                                    if (active) {
                                        ctr.setStyle('display', 'block');
                                    } else {
                                        ctr.setStyle('display', 'none');
                                    }
                                });
                                break;

                            case 'border-color':

                                self.sm.addEvent('show', function (active) {
                                    var s = self.controlled.fireEvent(type + ':get', function (color) {
                                        currentColor = color;
                                        cPreview.setStyle('background-color', color);
                                    });
                                });
                                break;
                            case 'object-effect-color':
                                self.sm.addEvent('show', function (active) {
                                    self.controlled.fireEvent(type + ':get', function (color, transparent) {
                                        currentColor = color;
                                        cPreview.setStyle('background-color', color);
                                        cPreview.classList[(transparent) ? 'add' : 'remove']('transparent');
                                    });
                                });

                                self.addEvent('reset-object-effects', function (e) {
                                    currentColor = '#fff';
                                    cPreview.setStyle('background-color', currentColor);
                                    cPreview.classList['add']('transparent');
                                    if (self.controlled) self.controlled.fireEvent(type, {
                                        'r': 255,
                                        'g': 255,
                                        'b': 255,
                                        'a': 1
                                    });
                                    self.dispatch('user:interaction', 1);
                                });

                                break;
                            default:
                                self.sm.addEvent('show', function (active) {
                                    //console.warn('Show ----> %s',type+':get');
                                    self.controlled.fireEvent(type + ':get', function (color) {
                                        currentColor = color;
                                        //console.log('Color:', color);
                                        cPreview.setStyle('background-color', 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')');
                                    });
                                });
                                break;
                        }

                    }
                break;

                /** CHECKBOX **/   
                case 'checkbox':
                    var sl=new GS.Toolbar.Checkbox(ctr,{'debug':0,'property':type,'checked':0});
                    sl.addEvent('change',function(v){
                        if(typeof v !== 'undefined') {
                            self.sm.fireEvent('disabled',!v);
                            self.controlled.fireEvent(type,v);
                            self.dispatch('user:interaction',1);
                        }
                    });

                    switch(type){
                        case 'inner-shadow-on':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getInnerShadow(type);
                                sl.fireEvent('set',s);
                                self.sm.fireEvent('disabled',!s);
                            });
                            break;
                         case 'shadow-on':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getShadow(type);
                                sl.fireEvent('set',s);
                                self.sm.fireEvent('disabled',!s);
                            });
                         break;
                         case 'background-on':
                            /*self.sm.addEvent('show',function(active){
                            });*/
                         break;
                        case 'multiply':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getPresetImageColorsEffects(type);
                                sl.fireEvent('set',s);
                            });
                            self.addEvent('reset-colors-effects',function(e){
                                self.controlled.fireEvent(type,false);
                                sl.fireEvent('set',false);
                                self.dispatch('user:interaction',1);
                            });
                            break;
                         case 'sepia':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getPresetImageColorsEffects(type);
                                sl.fireEvent('set',s);
                            });
                            self.addEvent('reset-colors-effects',function(e){
                                self.controlled.fireEvent(type,false);
                                sl.fireEvent('set',false);
                                self.dispatch('user:interaction',1);
                            });
                          break;
                          case 'object-effect-colorize':
                                self.addEvent('reset-object-effects',function(e){
                                    var s = 0;
                                    sl.fireEvent('set',false);
                                    self.controlled.fireEvent(type,false);
                                    self.dispatch('user:interaction',1);
                                });
                          break;
                          case 'effect-colorize':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getPresetImageColorsEffects(type);
                                sl.fireEvent('set',s);
                            });
                            
                          break;
                          case 'bw':
                            self.sm.addEvent('show',function(active){
                                var s=self.controlled.getPresetImageColorsEffects(type);
                                sl.fireEvent('set',s);
                            });
                            
                            self.addEvent('reset-colors-effects',function(e){
                                self.controlled.fireEvent(type,false);
                                sl.fireEvent('set',false);
                                self.dispatch('user:interaction',1);
                            });
                            
                          break;

                     }
                    //console.debug(type);

                break;

                case 'select':
                    break;
            
                case 'btns':
                case 'btn':
                    //console.warn('Found button: %s',type);
                break;
                
                case 'full-btn':
                    ctr.addEvent('click',function(e){
                        e.stop();
                        self.fireEvent(type);
                        if(self.controlled) self.updatePermissions(self.controlled.getPermissions());
                        self.dispatch('user:interaction',1);
                    });
                break;
                case 'toggler':
                    ctr.active=1;
                    let inp = ctr.querySelector('input');

                    ctr.addEventListener('click',function(e){
                        console.warn(this, self.controlled);
                        if(inp) inp.checked = !inp.checked;
                        if(inp.checked){
                            if(window.enableSplitImage) window.enableSplitImage(self.controlled.options.geometry.image || {});
                        }else{
                            if(window.disableSplitImage) window.disableSplitImage();
                        }
                    })
                    break;
                
                default:
                    ctr.active=1;

                    if(type){
                        this.addEvent(type,function(e){
                            ctr.active=(e) ? 1 : 0;
                            ctr.setStyle('display',(e) ? 'block' : 'none');
                        });
                    }
                    ctr.addEvent('click',function(e){
                        e.stop();
                       // console.warn('CLICK ON: %s', type);
                        if(!this.active) return;
                        let ghostSelection = document.getElementById('ghost-selection');
                        switch(type){
                            case 'align-vcenter':
                            case 'align-hcenter':
                            case 'align-bottom':
                            case 'align-left':
                            case 'align-right':
                            case 'align-top':
                                console.warn('ALIGN TO MULTI SELECTION')
                                if(window.alignInSelection && ghostSelection && ghostSelection.dataset && ghostSelection.dataset.version === 'multy'){
                                    window.alignInSelection(type)
                                    return;
                                }
                                break;
                            case 'send-to-front-one-level':
                            case 'send-to-back-one-level':
                            case 'send-to-back':
                                if(window.reorderSelection && ghostSelection && ghostSelection.dataset && ghostSelection.dataset.version === 'multy'){
                                    window.reorderSelection(type)
                                    return;
                                }
                                break;
                            default:
                                break;
                        }
                        if(self.controlled && type) self.controlled.fireEvent(type);
                        self.dispatch('user:interaction',1);
                    });
                break;
            }

        });



        w.addEvent('click',function(e){
            e.stop();
            console.warn('CLICK', e.event.target, w);
            if(e.event.target !== w && w.contains(e.event.target)) return;
            let s;
            if(['align-menu',"image-menu"].indexOf(e.event.target.dataset.type) !== -1){
                s = (self.sm.getStyle('display') !== 'flex') ? 'flex' : 'none';
            }else{
                s= (self.sm.getStyle('display') !== 'block') ? 'block' : 'none';
            }
            self.sm.setStyle('display',s);
            (['flex','block'].indexOf(s) !== -1) ? this.addClass('selected') : this.removeClass('selected');
            self.toolbar.fireEvent('submenu:show',this);
            //self.toolbar.dispatch('toolbar:submenu:show',this);
        });
        w.empty().adopt(this.sm);
    };

    f.prototype.menuTMPL=function(){
        return '';
    };
    
    this.Tools = f;
    
}.call(this.GS.Toolbar));
